var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2813_36374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.9372 16.4459V54.5676H21.6309V16.4459C21.6309 13.4382 24.0691 11 27.0768 11H52.4912C55.4978 11 57.9372 13.4382 57.9372 16.4459Z",
    fill: "#00FF66"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.6309 54.5676V63.6442C21.6309 66.6508 24.0691 69.0901 27.0768 69.0901H52.4912C55.499 69.0901 57.9372 66.652 57.9372 63.6442V54.5676H21.6309ZM39.784 65.4595C37.7701 65.4595 36.1534 63.8428 36.1534 61.8289C36.1534 59.815 37.7701 58.1983 39.784 58.1983C41.7979 58.1983 43.4146 59.815 43.4146 61.8289C43.4146 63.8428 41.8036 65.4595 39.784 65.4595Z",
    fill: "#00FF66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2813_36374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.5676,
    height: 58.0901,
    fill: "white",
    transform: "translate(18 11)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.793d688c070b5797b56afba56d52a77c.svg";
export { ForwardRef as ReactComponent };